import { rfqConfirmationHeaderStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader";
import { rfqConfirmationProductListStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationProductList";
import { css } from "styled-components";

rfqConfirmationHeaderStyles.viewQuotesButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

rfqConfirmationHeaderStyles.continueButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};
rfqConfirmationHeaderStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #fff !important;
            }
            ul {
                background: #fff;
            }
        `,
    },
};

rfqConfirmationProductListStyles.backToTopButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin: 16px 0;
    `,
};
